/*       */

import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Button, Typography, FormHelperText } from '@mic3/platform-ui';
import styled from 'styled-components';

import Geocode from 'app/utils/maps/geocodeUtils';
import { showToastr } from 'store/actions/app/appActions';
import { bind, memoize } from 'app/utils/decorators/decoratorUtils';
import { get } from 'app/utils/lo/lo';
import { loadEntityGeotagButton } from 'store/actions/entities/entitiesActions';
import LocationMap from 'app/components/molecules/Map/LocationMap/LocationMap';

const TypographyStyled = styled(Typography)`
    padding: 8px 0;
`;
const Wrapper = styled.div`
    margin: 10px 0;
`;

const RequiredStar = styled.span`
    color: red;
    margin-left: 5px;
`;

class GeotagButton extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            user: this.props.value || null,
            remoteLocation: null,
            mapKey: 1,
        };
        this.reloadRemoteLocation();
    }

    componentDidUpdate(prevProps) {
        const { remoteRef, value, data } = this.props;
        if ((remoteRef && get(data, `${remoteRef}.id`) !== get(prevProps, `data.${remoteRef}.id`)) || prevProps.value !== value) {
            this.reloadRemoteLocation();
        }
    }

    @bind
    async reloadRemoteLocation() {
        const { remoteRef, data, loadEntityGeotagButton, value } = this.props;
        const { id, type } = data[remoteRef] || {};
        let remoteLocation = null;
        if (id && type) {
            const response = await loadEntityGeotagButton(id, type);
            remoteLocation = get(response, 'primary.locationInfo.lat') && {
                lat: get(response, 'primary.locationInfo.latitude'),
                lng: get(response, 'primary.locationInfo.longitude'),
            };
        }
        this.setState(state => ({ remoteLocation, mapKey: state.mapKey + 1, user: value }));
    }

    @bind
    handleOnClick() {
        Geocode.getCurrentLocation(
            response => {
                this.setState(
                    state => ({
                        user: {
                            lat: get(response, 'coords.latitude', null),
                            lng: get(response, 'coords.longitude', null),
                        },
                        remoteLocation: null,
                        mapKey: state.mapKey + 1,
                    }),
                    () => {
                        this.props.onChange({ target: { name: this.props.name, value: this.state.user } });
                    }
                );
            },
            err => {
                if (err && err.code === 1) {
                    this.props.showToastr({ severity: 'error', detail: `Please enable your location sharing.` });
                }
            }
        );
    }

    @bind
    @memoize()
    getMarkers(user, remoteLocation) {
        const markers = [user];
        if (remoteLocation) {
            markers.push(remoteLocation);
        }
        return markers;
    }

    render() {
        const { label, error, helperText, required, disabled, onMouseDown } = this.props;
        const { user, remoteLocation } = this.state;
        const markers = this.getMarkers(user, remoteLocation);
        const distance = Geocode.calcDistance(markers[0], markers[1]);
        return (
            <Wrapper>
                <Button onClick={this.handleOnClick} disabled={disabled} onMouseDown={onMouseDown}>
                    {label || 'My location'} {required ? <RequiredStar>*</RequiredStar> : null}
                </Button>
                {error && helperText && <FormHelperText error={error}>* {helperText}</FormHelperText>}
                {user && (
                    <div>
                        {distance && <TypographyStyled>Distance: {distance}km</TypographyStyled>}
                        <LocationMap mapId={`geo_button_map`} markers={markers} />
                    </div>
                )}
            </Wrapper>
        );
    }
}

export default connect(null, { showToastr, loadEntityGeotagButton })(GeotagButton);

